import { Vue } from 'vue-property-decorator';

// TODO: add other colours once known and update SetTheme funtion
export class Theme {
  public primary!: string;
  public secondary!: string;
}

export function SetTheme(componentInstance: Vue, theme: Theme) {
  // set values
  componentInstance.$vuetify.theme.primary = theme.primary;
  componentInstance.$vuetify.theme.secondary = theme.secondary;
}
